import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

import { DiagnosticRating } from '@malou-io/package-utils';

import { Icon } from ':shared/enums';
import { ImagePathResolverPipe } from ':shared/pipes';
import { getKeywordRatingFromPosition } from ':shared/utils';

@Component({
    selector: 'app-keyword-google-position',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        ImagePathResolverPipe,
        NgTemplateOutlet,
        NgClass,
    ],
    templateUrl: './keyword-google-position.component.html',
    styleUrl: './keyword-google-position.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeywordGooglePositionComponent {
    readonly googlePosition = input.required<number>();
    readonly withSubtitle = input<boolean>(true);
    readonly shouldShowAsChip = input<boolean>(false);

    readonly DiagnosticRating = DiagnosticRating;
    readonly Icon = Icon;
    readonly MAX_GOOD_KEYWORD_RANK = 10;

    readonly keywordRating = computed(() => getKeywordRatingFromPosition(this.googlePosition()));

    readonly displayedRating = computed(() => {
        if (this.googlePosition() >= 20) {
            return '+20';
        }
        return this.googlePosition().toString();
    });

    readonly isBadRanking = computed(() => this.googlePosition() > this.MAX_GOOD_KEYWORD_RANK);
}
